import { SVGProps } from 'react';

export function Dollar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={48}
      width={48}
      viewBox="0 0 48 48"
      className={`${props.className} fill-current`}
      {...props}
    >
      <path d="M22.55 42v-4.2q-2.85-.5-4.675-2.175Q16.05 33.95 15.25 31.4l2.8-1.15q.85 2.4 2.45 3.575Q22.1 35 24.35 35q2.4 0 3.95-1.2 1.55-1.2 1.55-3.3 0-2.2-1.375-3.4-1.375-1.2-5.175-2.45-3.6-1.15-5.375-3.05t-1.775-4.75q0-2.75 1.775-4.6 1.775-1.85 4.625-2.1V6h3v4.15q2.25.25 3.875 1.475T31.9 14.75l-2.8 1.2q-.7-1.6-1.875-2.325-1.175-.725-3.075-.725-2.3 0-3.65 1.05t-1.35 2.85q0 1.9 1.5 3.075 1.5 1.175 5.55 2.425 3.4 1.05 5.025 3.025Q32.85 27.3 32.85 30.3q0 3.15-1.85 5.075-1.85 1.925-5.45 2.475V42Z" />
    </svg>
  );
}

export default Dollar;
